import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ReportSalesMonthlyResponseV4Schema } from "../response/ReportSalesMonthlyResponseV4";
import { ReportSalesMonthlyFilterV4Type } from "../schema/ReportSalesMonthlyFilterSchemaV4";

const API_VERSION = 'v4';

interface ReportSalesMonthlyV4Props {
    filter?: ReportSalesMonthlyFilterV4Type;
    type: string | null;
}

const useReportSalesMonthlyV4 = (params: ReportSalesMonthlyV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-report-sales-monthly',
            API_VERSION,
            params.type,
            JSON.stringify(params.filter)
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.post(`/${API_VERSION}/channel-manager/group-report-reservation-sales`, {
                    filter: params.filter
                });

                const validationResult = ReportSalesMonthlyResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Sales Monthly V4 report data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Sales Monthly V4 report`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && params.type === "report_sales_monthly",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useReportSalesMonthlyV4;